export function showTimelineNav() {
  const nav = document.getElementById("tl-nav");
  if (nav) nav.classList.remove("hidden");
}
